





















import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import StLoaderIcon from '@/components/basic/StLoaderIcon.vue';
import {UserStore} from '@/store/user-module';
import {SuccessButtonColorEnum} from '@/services/api/nswag/stapiclient_generated';
import {successButtonColorClass} from '@/utlitities/color';

@Component({
  components: {StLoaderIcon},
})
export default class StButton extends Vue {
  @Prop() disabled!: boolean;
  @Prop() loading!: boolean;
  @Prop() icon!: string;
  @Prop() type!: string;
  @Prop() tooltip!: string;

  get successButtonColor(){
    return successButtonColorClass(UserStore.userSettings.successButtonColor)
  }

  @Emit('click')
  click() {
    return;
  }
}
